import React from "react";
import { ShoppingBag, CreditCard, CheckCircle2 } from "lucide-react";

const STEPS = [
  { id: "cart", label: "Bag", icon: ShoppingBag },
  { id: "checkout", label: "Payment", icon: CreditCard },
  { id: "done", label: "Confirmed", icon: CheckCircle2 },
];

export function CheckoutSteps({ current }) {
  const currentIndex = STEPS.findIndex((s) => s.id === current);

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4 mb-12 select-none">
      {STEPS.map((step, i) => {
        const done = i < currentIndex;
        const active = i === currentIndex;
        const Icon = step.icon;
        return (
          <React.Fragment key={step.id}>
            <div className="flex items-center gap-2">
              <div
                className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors duration-300"
                style={{
                  background: done || active ? "#1E9AFF" : "rgba(255,255,255,0.06)",
                  border: active ? "2px solid #3FA9FF" : "none",
                }}
              >
                <Icon size={15} color={done || active ? "#fff" : "rgba(245,241,234,0.4)"} />
              </div>
              <span
                className="text-xs sm:text-sm uppercase tracking-widest hidden sm:inline"
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  color: done || active ? "#F5F1EA" : "rgba(245,241,234,0.35)",
                }}
              >
                {step.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className="w-8 sm:w-16 h-px flex-shrink-0"
                style={{ background: i < currentIndex ? "#1E9AFF" : "rgba(255,255,255,0.1)" }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default CheckoutSteps;
